import React, { FunctionComponent } from 'react'
import MatchStatus, { BasicMatchStatusProps } from '../../../../Match/Status'

const DartsSetStatus: FunctionComponent<BasicMatchStatusProps> = ({ ...props }) => {
    return (
        <MatchStatus
            logoUrl="https://reshape.sport1.de/c/s/sportgroups/5/:widthx:height"
            logoTintColor="white"
            backgroundColor="basra"
            competitorType="PLAYER"
            {...props}
        />
    )
}
export default DartsSetStatus
